import React from 'react';
import PropTypes from 'prop-types';
import { withContext, LinkTile } from '@piggybank/core';
import { Consumer } from '../Field/context';
import pick from 'lodash/fp/pick';

const LinkTileInput = React.forwardRef(
  ({ value, onChange, touched, error, describers, ...props }, ref) => (
    <LinkTile
      role={'radio'}
      aria-checked={value ? 'true' : 'false'}
      aria-invalid={touched && error ? 'true' : 'false'}
      aria-describedby={describers}
      data-formfocusable
      {...props}
      ref={ref}
      opened={!!value}
      onClick={(event) => {
        return onChange({ event, value: true });
      }}
    />
  )
);

LinkTileInput.displayName = 'LinkTileInput';

LinkTileInput.propTypes = {
  heading: PropTypes.string.isRequired,
  textMap: PropTypes.shape({
    /**
     * Visually hidden clarifier
     */
    newWindow: PropTypes.string.isRequired,
  }),
  /** docgen-from-context:<Field/> */
  value: PropTypes.any.isRequired,
  /** docgen-from-context:<Field/> */
  onChange: PropTypes.func.isRequired,
  /** docgen-from-context:<Field/> */
  describers: PropTypes.any,
  /** docgen-from-context:<Field/> */
  touched: PropTypes.any,
  /** docgen-from-context:<Field/> */
  error: PropTypes.any,
};

export { LinkTileInput };

export default withContext(
  Consumer,
  pick(['value', 'onChange', 'describers', 'touched', 'error'])
)(LinkTileInput);
